module.exports = __webpack_public_path__ + "img/84f6eb6.png";